import api from './api';

const unwrap = (res, fallback) => {
  if (res && res.success === true) return { success: true, data: res.data };
  return { success: false, error: (res && (res.message || res.error)) || fallback };
};

class EmailAutomationService {
  async listAutomations(params = {}) {
    try {
      const res = await api.get('/admin/email-automations', params);
      return unwrap(res, 'Failed to list automations');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to list automations' };
    }
  }

  async getAutomation(id) {
    try {
      const res = await api.get(`/admin/email-automations/${id}`);
      return unwrap(res, 'Failed to fetch automation');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch automation' };
    }
  }

  async createAutomation(payload) {
    try {
      const res = await api.post('/admin/email-automations', payload);
      return unwrap(res, 'Failed to create automation');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to create automation' };
    }
  }

  async updateAutomation(id, payload) {
    try {
      const res = await api.put(`/admin/email-automations/${id}`, payload);
      return unwrap(res, 'Failed to update automation');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to update automation' };
    }
  }

  async deleteAutomation(id) {
    try {
      const res = await api.delete(`/admin/email-automations/${id}`);
      return unwrap(res, 'Failed to delete automation');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to delete automation' };
    }
  }

  async toggleStatus(id, status) {
    try {
      const res = await api.post(`/admin/email-automations/${id}/toggle`, status ? { status } : {});
      return unwrap(res, 'Failed to update status');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to update status' };
    }
  }

  async testFire(id, body = {}) {
    try {
      const res = await api.post(`/admin/email-automations/${id}/test`, body);
      return unwrap(res, 'Failed to test automation');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to test automation' };
    }
  }

  async getTriggerEvents() {
    try {
      const res = await api.get('/admin/email-automations/trigger-events');
      return unwrap(res, 'Failed to load trigger events');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to load trigger events' };
    }
  }
}

export default new EmailAutomationService();
